export default "__VITE_ASSET__7a91e86d__"